import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STOP_CONFIRM = '¿Detener esta generación?\n\n'
  + 'No se te cobra y el resultado se descarta.';

/**
 * Detiene una generación de verdad: la ejecución pasa a "cancelled" y, si ya
 * había una predicción en Replicate, se cancela ahí también. Devuelve true si
 * el estado cambió.
 */
export const stopExecution = async (executionId, { confirm = true } = {}) => {
  if (confirm && !window.confirm(STOP_CONFIRM)) return false;
  try {
    const res = await axios.post(`${API}/executions/${executionId}/stop`);
    if (res.data?.changed) toast.success('Generación detenida. No se te cobró.');
    else toast.info(`La generación ya había terminado (${res.data?.status}).`);
    return !!res.data?.changed;
  } catch (e) {
    toast.error(e.response?.data?.detail || 'No se pudo detener la generación');
    return false;
  }
};

export default stopExecution;
